import React from "react";
import "../styles/Policies.css";
import { Link } from "react-router-dom";

function Privacy() {
  return (
    <div className="Conditions-terms">
         <div className="breadcrumb">
          <Link to="/">Home</Link> /{" "}
          <Link to="/Privacy-Policy">Privacy Policy</Link>
        </div> 

      <h1 className="Condition">Privacy Policy</h1>

      <div className="content">
        <p>
          At Sankalp Ayurveda, we value your trust and are committed to
          safeguarding your privacy. We take appropriate measures to protect
          your personal details, payment information, and order-related data. We
          do not sell, rent, or disclose your information to any unauthorized
          third parties.
        </p>
      </div>

      <h3 className="section-title">1. User Information and Privacy</h3>
      <p className="text">
        We take stringent measures to protect the confidentiality, security, and
        integrity of all information you share with us.
      </p>

      <ul className="policy-list">
        <li>
          <strong>Data Security:</strong>
          <ul>
            <li>
              We use Secure Socket Layer (SSL) technology to encrypt personal
              and payment information.
            </li>
            <li>
              Only authorized employees can access your data. Any violation may
              result in disciplinary or legal action.
            </li>
            <li>
              Your data is stored securely to prevent unauthorized access or
              misuse.
            </li>
          </ul>
        </li>
      </ul>

      <h3 className="section-title">2. Secure Shopping at Sankalphealth10@gmail.com</h3>
      <p className="text">
        When shopping with us, your personal and payment information is
        protected using:
      </p>

      <ul className="policy-list">
        <li>Encryption technology</li>
        <li>Digital certificates</li>
        <li>Secure commerce servers</li>
        <li>Authentication protocols</li>
      </ul>

      <h3 className="section-title">3. User Registration</h3>
      <p className="text">
        To provide the best shopping experience, we collect limited personal
        information when you register or make a purchase.
      </p>

      <ul className="policy-list">
        <li>
          <strong>Information Collected:</strong>
          <ul>
            <li>
              Name, phone number, email address, billing/shipping address, and
              payment details.
            </li>
          </ul>
        </li>

        <li>
          <strong>Purpose of Collection:</strong>
          <ul>
            <li>To process and deliver your orders</li>
            <li>To contact you regarding your purchases</li>
            <li>To inform you about offers or updates (only if you opt-in)</li>
          </ul>
        </li>

        <li>
          <strong>Email Communication:</strong>
          <ul>
            <li>You may unsubscribe from promotional emails at any time.</li>
          </ul>
        </li>

        <li>
          <strong>Additional Records:</strong>
          <ul>
            <li>
              Purchase history and preferences may be stored to enhance user
              experience.
            </li>
          </ul>
        </li>
      </ul>

      <h3 className="section-title">4. Cookies</h3>
      <p className="text">
        Cookies help us enhance your browsing experience and save time.
      </p>
      <ul className="policy-list">
        <li>What cookies are</li>
        <li>How we use cookies</li>
        <li>Privacy assurance</li>
      </ul>

      <h3 className="section-title">5. Analysis and Reporting</h3>
      <p className="text">
        We analyze user data to improve website performance and services.
      </p>
      <ul className="policy-list">
        <li>Data collected for analytics purposes</li>
        <li>Used only to improve user experience</li>
      </ul>

      <h3 className="section-title">6. Server Logs</h3>
      <ul className="policy-list">
        <li>
          IP address, browser type, operating system, referring site, session
          duration, and access time
        </li>
        <li>This data is anonymized and used only for aggregate analysis</li>
      </ul>

      <h3 className="section-title">7. Service Providers</h3>
      <ul className="policy-list">
        <li>
          Services include website hosting, email communication, payment
          processing, and order fulfillment
        </li>
        <li>
          Data is shared strictly on a need-to-know basis and kept confidential
        </li>
      </ul>

      <h3 className="section-title">8. Changes to This Policy</h3>
      <p className="text">
        This Privacy Policy is part of our Terms of Use. By using
       Sankalphealth10@gmail.com, you agree to this policy.
      </p>

      <ul className="policy-list">
        <li>Policy updates may be made periodically and posted on this page</li>
        <li>We will not reduce your privacy rights without consent</li>
      </ul>

      <h3 className="section-title">9. Contact Us</h3>
      <p className="text">Sankalp Ayurveda Group</p>
      <p className="text">Sankalpveda Natural Pvt. Ltd.</p>

      <div className="email">
        <a href="mailto:Sankalphealth10@gmail.com">Email: Sankalphealth10@gmail.com </a>
      </div>
    </div>
  );
}

export default Privacy;
